import type { ReactNode } from "react";
import React from "react";
import { FormattedMessage } from "react-intl";
import Regex from "./Regex";

export const NoTrailingSpaceWithMessage = (
  message: ReactNode = (
    <FormattedMessage id="form.validations.no_trailing_space" />
  ),
) => {
  return Regex(new RegExp("^(\\S.*\\S|\\S)*$"), message);
};

export default NoTrailingSpaceWithMessage();
